"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _system = require("@mui/system");
var Block = (0, _system.styled)('div')({
  border: "1.5px solid #F1F1F1",
  paddingLeft: 30,
  paddingRight: 30,
  borderRadius: 5,
  marginTop: 20,
  backgroundColor: '#FFFFFF'
});
var BlockContent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(Block, props, props.children);
});
var _default = exports["default"] = BlockContent;